import { IconAtom, LabelAtom } from "../../atoms";
import { IToggle } from "../../interfaces/Toggle";
import styles from "./styles.module.scss";

interface Props {
  id: string;
  startIndex: number;
  toggles: IToggle[];
}

export function ToggleRowMolecule(props: Readonly<Props>) {
  const toggleComponent = (toggle: IToggle): JSX.Element => {
    let className = styles.toggle;

    if (!toggle.label) {
      const styleCenter = styles[`toggle--center`];
      className += ` ${styleCenter}`;
    }

    if (toggle.checked) {
      const styleChecked = styles[`toggle--checked`];
      className += ` ${styleChecked}`;
    }

    return (
      <button key={toggle.id} id={toggle.id} className={className} onClick={toggle.onClick}>
        {toggle.checked && <IconAtom icon={"icon-check-white"} size={"small"} alt={"checked"} />}
        {toggle.label && (
          <LabelAtom id={toggle.id + "_label"} type={toggle.checked ? "white" : "form"} for={toggle.id} bold>
            {toggle.label}
          </LabelAtom>
        )}
      </button>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        {props.toggles.map((toggleItem: IToggle) => {
          return toggleComponent(toggleItem);
        })}
      </div>
    </div>
  );
}
